<div class="modals__container">
  <div class="modals__header">
    <img mfpLazyImage class="modals__close" lazySrc="assets/icons/close.svg" (click)="close()" />
  </div>
  <div class="product-select">
    <h1 class="product-select__title">{{ 'PRODUCT_SELECT.TITLE' | translate }}</h1>
    <h3 class="product-select__subtitle">{{ 'PRODUCT_SELECT.SUBTITLE' | translate }}</h3>
    <div class="product-select__products">
      <swiper
        class="swiper-pagination-mobile-navigation-desktop"
        [allowTouchMove]="swiperConfig.allowTouchMove"
        [breakpoints]="swiperConfig.breakpoints"
        [index]="swiperConfig.index"
        [scrollbar]="swiperConfig.scrollbar"
        [navigation]="swiperConfig.navigation"
        [pagination]="swiperConfig.pagination"
        [spaceBetween]="swiperConfig.spaceBetween"
        [speed]="swiperConfig.speed"
      >
        <ng-template *ngFor="let product of products; let index = index" swiperSlide>
          <mfp-product-card
            [product]="product"
            [active]="currentProduct!.id"
            [currencyExchange]="currencyExchange"
            [targetAge]="currentTarget.insured.age"
            [insurance]="currentTarget.insurance"
            (productChange)="onProductChange($event)"
          >
            <div class="product-select__products-features">
              <ng-container *ngIf="product.projectedInvestment">
                <mfp-product-feature-investment
                  [currencyExchange]="currencyExchange"
                  [investment]="product.projectedInvestment"
                  [product]="product"
                  [selectPlaceholder]="product.projectedInvestment.projectionPlaceholder"
                  [selectValues]="product.projectedInvestment.projectionValues"
                  [disabled]="currentProduct?.id !== product.id || lifePlan.status === 'SENT'"
                  (investmentChange)="onInvestmentChange($event)"
                >
                </mfp-product-feature-investment>
              </ng-container>
              <mfp-product-feature-group-coverage
                placeholder="0.00"
                [coverages]="product.coverages"
                [product]="currentProduct?.id === product.id ? currentProduct! : product"
                [currencyExchange]="currencyExchange"
                [disabled]="currentProduct?.id !== product.id || lifePlan.status === 'SENT'"
                (coverageChange)="onCoverageChange($event)"
              ></mfp-product-feature-group-coverage>
              <ng-container *ngFor="let coverage of product.coverages">
                <ng-container *ngIf="!coverage.group">
                  <mfp-product-feature-coverage
                    placeholder="0.00"
                    [coverage]="coverage"
                    [product]="currentProduct?.id === product.id ? currentProduct! : product"
                    [currencyExchange]="currencyExchange"
                    [disabled]="currentProduct?.id !== product.id || lifePlan.status === 'SENT'"
                    (coverageChange)="onCoverageChange($event)"
                    [insuranceTarget]="currentTarget"
                  ></mfp-product-feature-coverage>
                </ng-container>
              </ng-container>
            </div>
          </mfp-product-card>
        </ng-template>
      </swiper>
    </div>

    <div class="product-select__actions">
      <mfp-button
        type="button"
        color="primary"
        fill="outline"
        [label]="'CANCEL' | translate"
        [disabled]="false"
        (click)="close()"
      ></mfp-button>

      <mfp-button
        class="product-select__actions-save"
        type="button"
        color="primary"
        fill="default"
        [label]="'SAVE' | translate"
        [disabled]="!validProduct() || lifePlan.status === 'SENT'"
        (click)="save()"
      ></mfp-button>
    </div>
  </div>
</div>
